import CoreLayout from './CoreLayout';
import { getSidebar, toggleMenuItem, toggleCaseMenuItem, allCardsExpanded, resizeRequired, resizeComplete, sidebarExpand, sidebarContract } from 'actions/layout';
import { getInternetUserList } from 'actions/user';
import { formStatusChange } from 'actions/homeowner/caseforms';
import { getSearchResults, getNewSearchResults } from 'actions/search';
import { getFieldRepList } from 'actions/homeowner/fieldReps';
import { getAppraiserList } from 'actions/appraiser';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
  return {
    sidebar: state.layout.sidebar,
    assignmentTool: state.assignment,
    searchText: state.search.searchText,
    token: state.user.profile.token,
    cardsExpanded: state.caseForms.allCardsExpanded,
    profile: state.user.profile,

    fetchingFiles: state.caseForms.fetchingFiles,
    files: state.caseForms.files,
    headerDefinitions: state.layout.header
  };
};

const mapDispatchToProps = (dispatch) => ({
  getSidebar() {
    dispatch(getSidebar());
  },
  toggleMenuItem(menuId) {
    dispatch(toggleMenuItem(menuId));
  },
  toggleCaseMenuItem(menuId) {
    dispatch(toggleCaseMenuItem(menuId));
  },
  getSearchResults(text, localResultsOnly) {
    dispatch(getSearchResults(text, localResultsOnly));
  },
  formStatusChange(formName, status, id) {
    dispatch(formStatusChange(formName, status, id));
  },
  allCardsExpanded(val) {
    dispatch(allCardsExpanded(val));
  },
  resizeRequired() {
    dispatch(resizeRequired());
  },
  resizeComplete() {
    dispatch(resizeComplete());
  },
  getInternetUserList(searchText) {
    dispatch(getInternetUserList(searchText));
  },
  getFieldRepList(search) {
    dispatch(getFieldRepList(search));
  },
  getAppraiserList(search) {
    dispatch(getAppraiserList(true, search));
  },
  sidebarExpand() {
    dispatch(sidebarExpand());
  },
  sidebarContract() {
    dispatch(sidebarContract());
  },
  getNewSearchResults(text) {
    dispatch(getNewSearchResults(text));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CoreLayout);
